import * as React from 'react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router, Route } from 'react-router-dom';
const { render } = require('react-snapshot');

// import registerServiceWorker from './registerServiceWorker';
import createStore from './store';
import Nav from './components/nav';
import LandingPage from './pages/landing';
import AboutPage from './pages/about';
import EventsPage from './pages/events';
import AccommodationsPage from './pages/accommodations';
import LocationPage from './pages/location';
import RegistryPage from './pages/registry';
import QuestionsPage from './pages/questions';
import ContactPage from './pages/contact';
import RsvpPage from './pages/rsvp';
import ThanksPage from './pages/thanks';
import AdminPage from './pages/admin';

import 'bulma/css/bulma.css';
import './base.css';

const store = createStore();
(window as any).store = store; // tslint:disable-line:no-any

function App(): JSX.Element {
  return (
    <Provider store={store}>
      <Router>
        <div className="app-root">
          <Nav />
          <Route exact path="/" component={LandingPage} />
          <Route exact path="/about" component={AboutPage} />
          <Route path="/events" component={EventsPage} />
          <Route path="/accommodations" component={AccommodationsPage} />
          <Route path="/location/:area?" component={LocationPage} />
          <Route exact path="/registry" component={RegistryPage} />
          <Route path="/questions" component={QuestionsPage} />
          <Route exact path="/contact" component={ContactPage} />
          <Route exact path="/rsvp" component={RsvpPage} />
          <Route exact path="/thanks" component={ThanksPage} />
          <Route exact path="/admin" component={AdminPage} />
        </div>
      </Router>
    </Provider>
  );
}

render(<App />, document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/index.tsx